import {
  Box,
  OutlinedInput,
  Button,
  Typography,
  Grid,
  IconButton,
  Divider,
  Paper,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import {
  AddCircleOutline as AddIcon,
  DeleteSweep as DeleteIcon,
  InfoOutlined as InfoIcon,
  MonetizationOnOutlined as PriceIcon,
} from "@mui/icons-material";
import { useEffect, useState } from "react";
import * as React from "react";
import { useHistory, useParams } from "react-router-dom";
import Layout from "../../components/layout";
import salonService from "../../services/salonServices";
import { DecryptData, EncryptData, jsonParser } from "../../helpers/helper";
import { toast } from "react-toastify";

export default function EditServices() {
  const history = useHistory();
  const { id } = useParams<{ id: string }>();

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [serviceType, setServiceType] = useState<number | null>(null);
  const [serviceName, setServiceName] = useState("");
  const [description, setDescription] = useState("");
  const [serviceTypeData, setServiceTypeData] = useState([]);
  const [price, setPrice] = useState("");

  // 🎯 Toggle for variations
  const [hasVariations, setHasVariations] = useState(false);

  // 🎯 Variations
  const [variations, setVariations] = useState<any[]>([]);

  // 🎯 Max price
  const maxPrice =
    variations.length > 0
      ? Math.max(
          ...variations.flatMap((v) =>
            v.options.map((o) => Number(o.price) || 0)
          )
        )
      : 0;

  // 🎯 Fetch existing data
  useEffect(() => {
    // console.log("121", DecryptData("PZ+CN3rzGBehIq6wbNabOQ=="));
    // console.log(DecryptData("SpyzpkSwVi0YljpeWFBCNQ=="));
    // console.log(DecryptData("czGenz6qOjxSOOOoww9v8g=="));
    // console.log(DecryptData("sqmiGxN0LFvcZKZNLpHchBgU7ACKnYXc+HSDdYtW5Fs="));
    // console.log(DecryptData("pyZkphG0wOmva6hhct633A=="));
    // console.log(DecryptData("fzSGuIu2HB1TLjO6KfFpNw=="));
    // console.log(DecryptData("dc4rx50X0ze7BAPlrwAcLQ=="));
    // console.log(DecryptData("1iE0dVKjwBlHkcfMTeBJfpKI/ncT6WkYtgOIw2P1RzU="));
    // console.log(DecryptData("bVTC1IenMwHG9n7BrByKYw=="));
    // console.log(DecryptData("QSlcf4HPQDrIcdDIABoc7Q=="));
    // console.log(DecryptData("25g6TSl8iTk6qLtexfbLmA=="));
    // console.log(DecryptData("4Y09x+g3QJYvR8FP9mzfcw=="));
    // console.log(DecryptData("KODmPCD4jdsh03+5r9Ia4A=="));
    // console.log(DecryptData("vqBOfVCTjco/awLTXpJo0w=="));
    // console.log(DecryptData("78CoqZlsauN69+4lWJIILg=="));
    // console.log(DecryptData("inxDpR37k1lm6vMjwuZ1yQ=="));
    // console.log(DecryptData("N2xYC3z2jS1Vz6I0Qsv/OdM8RsL38zfv73Y6tug7arE="));
    // console.log(DecryptData("oHHyaYZQ89pMqQgg2fI0/Em0iomTWFLt5G25zb1ejYA=")); 
    // console.log(DecryptData("AmtVGuGdNhuz0UKWMdbhAQ==")); // mehndi id-> 19
    // console.log(DecryptData("IF7qNIY7hS+8HMzP/rp27g==")); // hair styling id-> 20
    // console.log(DecryptData("dCkJzR0ZB/y23+LbI4p6LQ==")); // hair cut id-> 21
    // console.log(DecryptData("dCkJzR0ZB/y23+LbI4p6LQ==")); // hair cut id-> 22
    // console.log(DecryptData("8bw0gMHz1j/5uAhWbmrYWw==")); // Ramadahan deal id-> 23
    // console.log(DecryptData("8bw0gMHz1j/5uAhWbmrYWw==")); // Ramadahan deal id-> 24
    // console.log(DecryptData("SInGATRhP9QS2jCLDFjuew==")); // Ramadaha deal id-> 25
    // console.log(DecryptData("SInGATRhP9QS2jCLDFjuew==")); // Ramadaha deal id-> 26
    // console.log(DecryptData("Co5De5x0VBrnyw/dsbjmwX5jXdBNUvn677mGRf6/8Eg="));
    // console.log(DecryptData("Co5De5x0VBrnyw/dsbjmwQaXHv8UKlLLgmSO8NU4Sac="));
    // console.log(DecryptData("Co5De5x0VBrnyw/dsbjmwR4fIjQjL7emmQRoxnsIUTY="));
    // console.log(DecryptData("Co5De5x0VBrnyw/dsbjmwW1dXnhKrzaFAo5P8GkSJM8="));

    // console.log(EncryptData("Highlights with base color,Hair trimming ,Protein wash,Blow Dry"));
    // console.log(EncryptData("Balayage,Hair cut,Protein wash,Blow dry"));
    // console.log(EncryptData("Extenso,Hair trimming,Protein wash"));

    // console.log(EncryptData("15000"));
    // console.log(EncryptData("20000"));
    // console.log(EncryptData("22000"));

    const fetchData = async () => {
      const res = await salonService.findOne(id);
      console.log(res);
      // Service Types
      const serviceTypes = jsonParser(DecryptData(res.serviceType)).map(
        (d) => ({
          ...d,
          serviceName: DecryptData(d.serviceName),
        })
      );
      setServiceTypeData(serviceTypes);

      // Service Data
      const service = jsonParser(DecryptData(res.serviceData));

      setServiceName(DecryptData(service.serviceName));
      setDescription(DecryptData(service.description));
      setServiceType(service.serviceTypeId);

      // 🎯 Determine if service has variations
      const serviceVariations = service.variations || [];
      if (serviceVariations.length > 0) {
        setHasVariations(true);
        setVariations(
          serviceVariations.map((v) => ({
            typeName: DecryptData(v.name),
            options: v.options.map((o) => ({
              name: DecryptData(o.name),
              price: DecryptData(o.price),
            })),
          }))
        );
      } else {
        // 🎯 If no variations, set the fixed price
        setHasVariations(false);
        setPrice(DecryptData(service.finalMaxPrice) || "");
      }
    };

    fetchData();
  }, [id]);

  // 🎯 Variation handlers (same as Add)
  const addVariationType = () => {
    setVariations([
      ...variations,
      { typeName: "", options: [{ name: "", price: "" }] },
    ]);
  };

  const removeVariationType = (index) => {
    const copy = [...variations];
    copy.splice(index, 1);
    setVariations(copy);
  };

  const addOption = (i) => {
    const copy = [...variations];
    copy[i].options.push({ name: "", price: "" });
    setVariations(copy);
  };

  const removeOption = (i, oi) => {
    const copy = [...variations];
    copy[i].options.splice(oi, 1);
    setVariations(copy);
  };

  const handleVariationChange = (i, oi, field, value) => {
    const copy = [...variations];
    if (oi === null) {
      copy[i].typeName = value;
    } else {
      if (field === "price") value = value.replace(/[^0-9]/g, "");
      copy[i].options[oi][field] = value;
    }
    setVariations(copy);
  };

  const handlePriceChange = (e) => {
    let { value } = e.target;
    value = value.replace(/[^0-9]/g, "");
    setPrice(value);
  };

  // 🎯 Submit
  const onSubmit = async () => {
    if (!serviceName || !serviceType) {
      toast.error("Please fill all required fields");
      return;
    }

    setIsSubmitting(true);

    try {
      const payload = {
        serviceName: EncryptData(serviceName),
        description: EncryptData(description),
        serviceTypeId: Number(serviceType),
        // 🎯 Conditional variations logic
        variations: hasVariations
          ? variations.map((v) => ({
              name: EncryptData(v.typeName),
              options: v.options.map((o) => ({
                name: EncryptData(o.name),
                price: EncryptData(o.price.toString()),
              })),
            }))
          : [],
        finalMaxPrice: EncryptData(hasVariations ? maxPrice.toString() : price),
      };

      await salonService.update(id, payload);
      toast.success("Service updated successfully");
      history.push("/services");
    } catch {
      toast.error("Failed to update service");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Layout>
      <Box sx={{ p: { xs: 2, md: 4 }, maxWidth: "1400px", margin: "0 auto" }}>
        {/* Header */}
        <Box
          sx={{
            mb: 4,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Box>
            <Typography variant="h4" className="page-main-title">
              Edit Service
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {hasVariations
                ? "Update service details with tiered pricing variations."
                : "Update service details with a fixed price."}
            </Typography>
          </Box>
          <button
            className="btn-save-top"
            onClick={onSubmit}
            disabled={isSubmitting}
          >
            {isSubmitting ? "Saving..." : "Update Service"}
          </button>
        </Box>

        <Grid container spacing={4}>
          {/* LEFT */}
          <Grid item xs={12} lg={4}>
            <Paper elevation={0} className="info-card-container">
              <Typography variant="h6" className="section-subtitle">
                General Details
              </Typography>
              <Divider sx={{ mb: 3 }} />

              <div className="form-field">
                <label>Service Category</label>
                <select
                  className="modern-input"
                  value={serviceType || ""}
                  onChange={(e) => setServiceType(Number(e.target.value))}
                >
                  <option value="">Select Category</option>
                  {serviceTypeData.map((row, i) => (
                    <option key={i} value={row.id}>
                      {row.serviceName}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-field">
                <label>Service Name</label>
                <OutlinedInput
                  fullWidth
                  className="modern-text-input"
                  value={serviceName}
                  onChange={(e) => setServiceName(e.target.value)}
                />
              </div>

              <div className="form-field">
                <label>Description</label>
                <textarea
                  className="modern-textarea"
                  rows={6}
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                />
              </div>

              {/* 🎯 Variation Toggle */}
              <Box sx={{ mt: 3, pt: 3, borderTop: "1px solid #eee" }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={hasVariations}
                      onChange={(e) => {
                        setHasVariations(e.target.checked);
                        // Reset variations when toggling off
                        if (!e.target.checked) {
                          setVariations([]);
                        }
                      }}
                    />
                  }
                  label={
                    <Box>
                      <Typography variant="body2" sx={{ fontWeight: 600 }}>
                        This service has variations
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        Enable if service has different options (e.g., sizes,
                        lengths)
                      </Typography>
                    </Box>
                  }
                />
              </Box>
            </Paper>
          </Grid>

          {/* RIGHT */}
          <Grid item xs={12} lg={8}>
            {!hasVariations ? (
              // 🎯 Simple Pricing (No Variations)
              <Paper elevation={0} className="info-card-container">
                <Typography variant="h6" className="section-subtitle">
                  Service Price
                </Typography>
                <Divider sx={{ mb: 3 }} />

                <Box sx={{ p: 3, backgroundColor: "#f9f9f9", borderRadius: 2 }}>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ mb: 2 }}
                  >
                    Enter the fixed price for this service
                  </Typography>

                  <Box sx={{ display: "flex", gap: 2, alignItems: "flex-end" }}>
                    <Box sx={{ flex: 1 }}>
                      <label style={{ display: "block", marginBottom: 8 }}>
                        Price
                      </label>
                      <OutlinedInput
                        fullWidth
                        type="text"
                        placeholder="Enter price"
                        value={price}
                        onChange={handlePriceChange}
                        startAdornment={
                          <Typography sx={{ mr: 1, fontSize: 14 }}>
                            Rs
                          </Typography>
                        }
                      />
                    </Box>
                    {price && (
                      <Box
                        sx={{
                          p: 2,
                          backgroundColor: "#719879",
                          color: "white",
                          borderRadius: 1,
                          textAlign: "center",
                          minWidth: 120,
                        }}
                      >
                        <Typography variant="caption">Final Price</Typography>
                        <Typography variant="h6" sx={{ fontWeight: 800 }}>
                          Rs. {Number(price).toLocaleString()}
                        </Typography>
                      </Box>
                    )}
                  </Box>
                </Box>
              </Paper>
            ) : (
              // 🎯 Variations Pricing
              <Paper elevation={0} className="info-card-container">
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    mb: 3,
                  }}
                >
                  <Box>
                    <Typography variant="h6" className="section-subtitle">
                      Pricing & Variations
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      The final price will be the{" "}
                      <strong style={{ color: "#719879" }}>
                        highest value
                      </strong>{" "}
                      among selected variations.
                    </Typography>
                  </Box>
                  <Button
                    variant="contained"
                    startIcon={<AddIcon />}
                    onClick={addVariationType}
                    className="btn-add-category"
                  >
                    Add Variation Group
                  </Button>
                </Box>

                {variations.length === 0 ? (
                  <Box className="empty-variation-state">
                    <PriceIcon sx={{ fontSize: 40, color: "#ccc" }} />
                    <Typography>No variations added</Typography>
                  </Box>
                ) : (
                  variations.map((v, i) => (
                    <div key={i} className="variation-module">
                      <Box className="variation-header">
                        <OutlinedInput
                          size="small"
                          value={v.typeName}
                          placeholder="Variation Group"
                          onChange={(e) =>
                            handleVariationChange(
                              i,
                              null,
                              "typeName",
                              e.target.value
                            )
                          }
                          className="group-title-input"
                        />
                        <IconButton onClick={() => removeVariationType(i)}>
                          <DeleteIcon />
                        </IconButton>
                      </Box>

                      <Box sx={{ p: 2 }}>
                        {v.options.map((o, oi) => (
                          <div key={oi} className="option-row">
                            <OutlinedInput
                              size="small"
                              value={o.name}
                              placeholder="Option Name"
                              onChange={(e) =>
                                handleVariationChange(
                                  i,
                                  oi,
                                  "name",
                                  e.target.value
                                )
                              }
                              sx={{ flex: 2 }}
                            />
                            <OutlinedInput
                              size="small"
                              value={o.price}
                              placeholder="Price"
                              onChange={(e) =>
                                handleVariationChange(
                                  i,
                                  oi,
                                  "price",
                                  e.target.value
                                )
                              }
                              sx={{ flex: 1 }}
                              startAdornment={
                                <Typography sx={{ mr: 1, fontSize: 12 }}>
                                  Rs
                                </Typography>
                              }
                            />
                            <IconButton
                              size="small"
                              onClick={() => removeOption(i, oi)}
                            >
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          </div>
                        ))}
                        <Button
                          size="small"
                          startIcon={<AddIcon />}
                          onClick={() => addOption(i)}
                          className="btn-add-option"
                        >
                          Add Option
                        </Button>
                      </Box>
                    </div>
                  ))
                )}

                {maxPrice > 0 && (
                  <Box className="logic-summary-footer">
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <InfoIcon color="success" fontSize="small" />
                      <Typography variant="body2">
                        Automatic Pricing Rule Active
                      </Typography>
                    </Box>
                    <Box sx={{ textAlign: "right" }}>
                      <Typography variant="caption">
                        Maximum Service Value
                      </Typography>
                      <Typography
                        variant="h4"
                        sx={{ fontWeight: 800, color: "#719879" }}
                      >
                        Rs. {maxPrice.toLocaleString()}
                      </Typography>
                    </Box>
                  </Box>
                )}
              </Paper>
            )}
          </Grid>
        </Grid>
      </Box>
    </Layout>
  );
}
